<template>
  <v-container class="transaction-success">
    <div class="subscription-header mb-8">
      <h1 class="text-h5 font-weight-medium">{{ $t('global.subscription.mySubscriptions') }}</h1>
      <div class="blue-underline"></div>
    </div>

    <v-row justify="center" align="center" class="success-content">
      <v-col cols="12" md="6" class="text-center">
        <div class="success-icon-wrapper mb-6">
          <v-icon color="success" size="80">mdi-check-circle</v-icon>
        </div>
        <h2 class="success-title text-h4 font-weight-medium mb-4">
          {{ $t('global.transaction.successTitle') }}
        </h2>
        <p class="success-message text-body-1 text-medium-emphasis mb-6">
          {{ $t('global.transaction.successMessage') }}
        </p>
        <v-btn
          color="#0073e6"
          x-large
          rounded
          min-width="200"
          height="56"
          class="dashboard-button white--text"
          @click="goToDashboard"
        >
          <v-icon left size="24">mdi-view-dashboard</v-icon>
          <span class="font-weight-bold text-h6">{{ $t('global.goToDashboard') }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { markTransactionPaid } from '@/graphql/mutations/markTransactionPaid'

export default {
  name: 'TransactionSuccess',
  mounted() {
    const transactionId = this.$route.query.transId
    if (!transactionId) {
      console.warn('No transactionId found in route params')
      return
    }

    this.markTransactionPaidOnMount(transactionId)
  },
  methods: {
    goToDashboard() {
      this.$router.push('/')
    },
    async markTransactionPaidOnMount(transactionId) {
      try {
        const result = await this.$apollo.mutate({
          mutation: markTransactionPaid,
          variables: {
            transactionId,
          },
        })

        const response = result?.data?.markTransactionPaid

        if (response?.code === '0' || response?.code === 0) {
          console.log('Transaction successfully marked as paid:', response)
          // Optional redirect if needed:
          if (response.redirect) {
            window.location.replace(response.redirect)
          }
        } else {
          this.$toast?.error(response?.message || this.$t('global.transaction.markFailed'))
          console.warn('Unexpected response from mutation:', response)
        }
      } catch (error) {
        console.error('Error calling markTransactionPaid mutation:', error)
        this.$toast?.error(this.$t('global.transaction.markError'))
      }
    },
  },
}
</script>

<style lang="less" scoped>
.transaction-success {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
  padding-top: 2rem;
}

.subscription-header {
  padding: 1rem 1.5rem;
  background-color: #f0f7ff;
  border-radius: 4px;
  position: relative;

  h1 {
    margin: 0;
    padding: 0.5rem 0;
    color: #333;
  }

  .blue-underline {
    position: absolute;
    bottom: 0;
    left: 1.5rem;
    width: 180px;
    height: 3px;
    background-color: #0073e6;
    border-radius: 2px;
  }
}

.success-content {
  padding: 64px 0;
  flex: 1;
}

.success-icon-wrapper {
  display: inline-flex;
  padding: 16px;
  border-radius: 50%;
  background-color: rgba(var(--v-theme-success), 0.1);
}

.success-title {
  color: rgb(var(--v-theme-on-surface));
  line-height: 1.2;
}

.success-message {
  max-width: 400px;
  margin: 0 auto;
}

.dashboard-button {
  background-color: #0073e6 !important;
  box-shadow: 0 4px 10px rgba(0, 115, 230, 0.3) !important;
  transition: transform 0.2s, box-shadow 0.2s !important;
  font-weight: 600 !important;
}

.dashboard-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 115, 230, 0.4) !important;
}
</style>
